import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReportOrder } from '../models/ReportOrder';
import { CONSTANTES } from '../shared/global';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  public url: string;

    constructor(private http: HttpClient) {
        this.url = CONSTANTES.api_url + "/reports";
    }

    getReportStore(datos: ReportOrder){
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post<ReportOrder>(this.url + "/store", JSON.stringify(datos),{ headers: iheaders });
    }

    getReportOrder(datos: ReportOrder){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<ReportOrder>(this.url + "/order", JSON.stringify(datos),{ headers: iheaders });
    }

    getReportOrderFinished(datos: ReportOrder){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<ReportOrder>(this.url + "/orderFinished", JSON.stringify(datos),{ headers: iheaders });
    }

    getReportOrderPreparation(datos: ReportOrder){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<ReportOrder>(this.url + "/preparation", JSON.stringify(datos),{ headers: iheaders });
    }

    getReportOrderAddress(datos: ReportOrder){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<ReportOrder>(this.url + "/address", JSON.stringify(datos),{ headers: iheaders });
    }

    getReportSales(datos: ReportOrder){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<ReportOrder>(this.url + "/sale", JSON.stringify(datos),{ headers: iheaders });
    }

    getReportConfirm(datos: ReportOrder){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<ReportOrder>(this.url + "/confirm", JSON.stringify(datos),{ headers: iheaders });
    }

    getReportTrackingOrders(datos: ReportOrder){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<ReportOrder>(this.url + "/tracking", JSON.stringify(datos),{ headers: iheaders });
    }

    getReportStock(datos: ReportOrder){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<ReportOrder>(this.url + "/stock", JSON.stringify(datos),{ headers: iheaders });
    }

    getReportSalesOfDay(datos: ReportOrder){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<ReportOrder>(this.url + "/salesClosedDay", JSON.stringify(datos),{ headers: iheaders });
    }

    getReportReturns(datos: ReportOrder){
      const iheaders = new HttpHeaders().set('Content-Type', 'application/json');
      return this.http.post<ReportOrder>(this.url + "/returnsReport", JSON.stringify(datos),{ headers: iheaders });
    }
}